import React, {useEffect} from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import {
    date_time_to_date_format,
    getCustomer, getRentsByCustomerId,
    getRoom,
    deleteCustomerDocuments,addCustomerDocuments,get_response_or_errors, remove_session
} from "../../../functions/general";
import ListTransactions from "../transactions/ListTransactions";
import ModalImage from "react-modal-image";

function CustomerDetails(props) {
    const currentUser = props.currentUser;
    const navigate = useNavigate();
    const [loading, setLoading] = React.useState(false);
    const [response, setResponse] = React.useState("");
    const params = useParams();
    const [documents, setDocuments] = React.useState("");
    const [name, setName] = React.useState("");
    const [previewdocuments, setCustomerDocs] = React.useState([]);
    const [customer, setCustomer] = React.useState([]);
    const [rent, setRent] = React.useState([]);
    const [errors, setErrors] = React.useState("");
    const onSubmit = (e) => {
        e.preventDefault()
        setResponse("");
        if (loading)
            return false;
        if (validate()) {
            setLoading(true);
            const customer = {
                id: params.id,
                name:name,
                documents:documents,
            }
            addCustomerDocuments(customer).then(res => {
                if (res && res.status == 200) {
                    setCustomerDocs(res.data.documents);
                } else if (res && res.status == 203) {
                    remove_session();
                    props.getLoggedInUser();
                    navigate('/login');
                } else {
                    setResponse(get_response_or_errors(res))
                    setLoading(false)
                }
            })
        }
    }
    const validate = () => {
        let errors = {
            documents: [],
            name: '',
        };
        let isValid = true;
        if (!documents) {
            isValid = false;
            errors.documents = "Please Choose Document.";
        }
        if (!name) {
            isValid = false;
            errors.name = "Please Enter name.";
        }
        setErrors(errors);
        return isValid;
    }
    const deleteHandler = (e, docId,path) => {
        e.preventDefault();
        const customer = {
            id: params.id,
            doc_id: docId,
            path: path,
        }
        if (window.confirm("Are you sure you want to delete document?") === true) {
            deleteCustomerDocuments(customer).then((res) => {
                if (res && res.status === 200) {
                    setCustomerDocs(res.data.documents);
                } else if (res && res.status === 203) {
                    remove_session();
                    props.getLoggedInUser();
                    navigate("/login");
                }
            });
        }
      };
    const docUploadHandler = (e) => {
        const files = e.target.files;
    
        // Ensure there are files to process
        if (files?.length > 0) {
            const newCustomerDocs = [];
    
            // Loop through each selected file
            for (let i = 0; i < files?.length; i++) {
                const file = files[i];
                const reader = new FileReader();
    
                reader.onloadend = function () {
                    // Append the base64 data of the file to the array
                    newCustomerDocs.push({
                        name: file.name,
                        type: file.type,
                        size: file.size,
                        data: reader.result,
                    });
    
                    // If all files are processed, update the state with the array of documents
                    if (i === files?.length - 1) {
                       console.log(newCustomerDocs);
                       setDocuments(newCustomerDocs);
                    }
                };
    
                // Read the file as data URL
                reader.readAsDataURL(file);
            }
        }
    }
    useEffect(() => {
        getCustomer(params.id).then(res => {
            if (res && res.status == 200) {
                if(res.data.data){
                    setCustomer(res.data.data);
                    setCustomerDocs(res.data.documents);
                } else {
                    navigate('/customers');
                }
            } else if (res && res.status == 203) {
                remove_session();
                props.getLoggedInUser();
                navigate('/login');
            }
        })
        getRentsByCustomerId(params.id).then(res => {
            if (res && res.status == 200) {
                setRent(res.data.data);
            } else if (res && res.status == 203) {
                remove_session();
                props.getLoggedInUser();
                navigate('/login');
            } else {
            }
        })
    }, [])
    const monthDiff = (dateFrom, dateTo) => {
        var months = dateTo.getMonth() - dateFrom.getMonth()
            + (12 * (dateTo.getFullYear() - dateFrom.getFullYear()));

        if(dateTo.getDate() < dateFrom.getDate()){
            months--;
        }
        return months;
    }
    const yearDiff = (dateFrom, dateTo) => {
        var years = dateTo.getFullYear() - dateFrom.getFullYear();

        if(dateTo.getDate() < dateFrom.getDate()){
            years--;
        }
        return years;
    }
    const getRentTillNow = (currentRent) => {
        let rentAmount = 0;
        if(currentRent.startDate){
            if(currentRent.rentType === '1'){
                let months = monthDiff(new Date(currentRent.startDate), new Date()) + 1;
                rentAmount = currentRent.rent * months
            }else{
                let years = yearDiff(new Date(currentRent.startDate), new Date()) + 1;
                rentAmount = currentRent.rent * years
            }
        }
        return rentAmount + parseInt(currentRent.overDaysRent);
    }
  return (
      <>
          <div className="col-lg-12">
              <div className="d-flex flex-wrap align-items-center justify-content-between">
                  <div>
                      <h4 className="mb-3 mt-5">Tenant Detail</h4>
                  </div>
              </div>
          </div>
          <div className="col-sm-12">
              <div className="card">
                  <div className="bg-black-custom card-header d-flex justify-content-between rounded-top">
                      <div className="header-title">
                          <h4 className="card-title text-white">{customer.name}</h4>
                      </div>
                  </div>
                  <div className="card-body">
                      <div className="row">
                          <div className="col-md-12">
                              <div className="form-group">
                                  <label>Name: </label> {customer.name}
                                  <br />
                                  <label>Phone: </label> {customer.phone}
                                  <br />
                                  <label>Passport: </label> {customer.passport}
                                  <br />
                                  <label>Emirates&nbsp;Id: </label> {customer.emiratesId}
                                  {customer.emiratesIdImage &&
                                  <div  className="transactionTableImage">
                                      <ModalImage
                                          small={process.env.REACT_APP_APIPATH + "/api/images/" + customer.emiratesIdImage}
                                          large={process.env.REACT_APP_APIPATH + "/api/images/" + customer.emiratesIdImage}
                                      />
                                  </div>}
                                  <br />
                                  <label>Country: </label> {customer.country}
                                  <br />
                                  <label>City: </label> {customer.city}
                                  <br />
                                  <label>State: </label> {customer.state}
                                  <br />
                                  <label>Address: </label> {customer.address}
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
            <div className="col-12">
            <h4 className="card-title text-dark">Documents</h4>
           
                        <div className="row">
                            <div className="col-12">
                                <form className="row justify-content-end" noValidate onSubmit={onSubmit}>
                                    <div className="col-12">
                                        {response?.responseMessage &&
                                        <div
                                            className={`alert alert-${response?.responseFlag} fade show`}
                                            role="alert">
                                            {response?.responseMessage}
                                        </div>
                                        }
                                    </div>
                                    <div className="col-md-8">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <input type="text" className="form-control" placeholder="Enter Name"
                                                            value={name} onChange={(e) => setName(e.target.value)}/>
                                                    <div className="text-warning font-size-12">{errors.name}</div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <div className="custom-file">
                                                        <input type="file" className="custom-file-input" id="doc" onChange={e => docUploadHandler(e)} multiple/>
                                                        <label className="custom-file-label" htmlFor="receipt">Choose
                                                            file</label>
                                                        <div className="text-warning font-size-12">{errors.documents}</div>
                                                        {documents && (documents?.length +' Files')} 
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <div className="col-lg-1 col-md-1">
                                        <button type="submit" className="btn btn-primary mr-2 w-100">Add</button> 
                                    </div>
                                </form>
                            </div>  
                            <div className="col-md-12">
                                <div className="table-responsive rounded mb-3">
                                <table className="data-table table mb-0 tbl-server-info">
                                    <thead className="bg-black-custom text-uppercase">
                                    <tr className="text-white">
                                        <th>No</th>
                                        <th>Document</th>
                                        <th>Action</th>
                                    </tr>
                                    </thead>
                                    <tbody className="bg-white">
                                        { previewdocuments?.length > 0 && previewdocuments.map((document, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{index+1}</td>
                                                    <td>
                                                        <h4> <a href={process.env.REACT_APP_APIPATH +"/api/uploads/" +document.path} target="_blank" > <i className="ri-download-fill mr-0"></i> {document.name}</a></h4> 
                                                    </td>
                                                    <td>
                                                        <a onClick={(e) => deleteHandler(e, document.id,document.path)}
                                                            className="badge bg-primary mr-2"
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            title=""
                                                            data-original-title="Delete"
                                                            href="#" >
                                                            <i className="ri-delete-bin-line mr-0"></i>
                                                        </a>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                
                                    </tbody>
                                </table>
                                </div>
                            </div>
                        </div>
                  </div>
          <div className="col-lg-12">
              <div className="d-flex flex-wrap align-items-center justify-content-between ">
                  <div>
                      <h4 className="mb-3 mt-5"> Current Rents</h4>
                  </div>
              </div>
          </div>
          <div className="col-lg-12">
              <div className="table-responsive rounded mb-3">
                  <table className="data-table table mb-0 tbl-server-info">
                      <thead className="bg-black-custom text-uppercase">
                      <tr className="text-white">
                          <th>Building</th>
                          <th>Room</th>
                          <th>Tenant</th>
                          <th>Rent</th>
                          <th>Pending</th>
                          <th>Start Date</th>
                          <th>Dewa</th>
                          <th>Maintenance</th>
                          <th>Action</th>
                      </tr>
                      </thead>
                      <tbody className="bg-white">
                      { rent?.length > 0 && rent.map((singleRent, index) => {
                          if(singleRent.endDate){
                              return;
                          }
                              return (
                                  <tr key={index}>
                                      <td>{singleRent.buildingName}</td>
                                      <td>{singleRent.roomName}</td>
                                      <td>{singleRent.customerName}</td>
                                      <td>
                                          {singleRent.rent} / {singleRent.rentType === '1' ? "Month" : "Year"}
                                          {singleRent.contractedImage &&
                                          <div  className="transactionTableImage">
                                              <ModalImage
                                                  small={process.env.REACT_APP_APIPATH + "/api/images/" + singleRent.contractedImage}
                                                  large={process.env.REACT_APP_APIPATH + "/api/images/" + singleRent.contractedImage}
                                              />
                                          </div>}
                                      </td>
                                      <td>{(getRentTillNow(singleRent) - (singleRent.rentCollected.amount ? singleRent.rentCollected.amount : 0)) > 0 ? (getRentTillNow(singleRent) - (singleRent.rentCollected.amount ? singleRent.rentCollected.amount : 0)) : 0}</td>
                                      <td>{date_time_to_date_format(singleRent.startDate)}</td>
                                      <td>
                                          {singleRent.dewa === '1' ?
                                              (<div className="font-weight-bold text-success">Yes</div>) :
                                              (<div className="font-weight-bold text-danger">No&nbsp;</div>)}
                                      </td>
                                      <td>
                                          {singleRent.maintenance === '1' ?
                                              (<div className="font-weight-bold text-success">Yes</div>) :
                                              (<div className="font-weight-bold text-danger">No&nbsp;</div>)}
                                      </td>
                                      <td>
                                          <div className="d-flex align-items-center list-action">
                                              <Link className="badge bg-primary mr-2" data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Detail" data-original-title="Detail"
                                                    to={'/rent/' + singleRent.id}><i
                                                  className="ri-eye-line mr-0"></i></Link>
                                              <Link className="badge bg-primary mr-2" data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Transaction" data-original-title="Transaction"
                                                    to={`/transactions/add?type=rent&id=${singleRent.id}`}><i
                                                  className="ri-money-dollar-circle-line mr-0"></i></Link>
                                              {/*<Link className="badge bg-success mr-2" data-toggle="tooltip"*/}
                                              {/*      data-placement="top"*/}
                                              {/*      title="" data-original-title="Checkout"*/}
                                              {/*      to={'/rooms/edit/' + singleRent.id}><i*/}
                                              {/*    className="ri-picture-in-picture-exit-fill mr-0"></i></Link>*/}
                                          </div>
                                      </td>
                                  </tr>
                              );
                      })}
                      </tbody>
                  </table>
              </div>
          </div>
          <div className="col-lg-12">
              <div className="d-flex flex-wrap align-items-center justify-content-between">
                  <div>
                      <h4 className="mb-3 mt-5"> Previous Rents</h4>
                  </div>
              </div>
          </div>
          <div className="col-lg-12">
              <div className="table-responsive rounded mb-3">
                  <table className="data-table table mb-0 tbl-server-info">
                      <thead className="bg-black-custom text-uppercase">
                      <tr className="text-white">
                          <th>Building</th>
                          <th>Room</th>
                          <th>Tenant</th>
                          <th>Rent</th>
                          <th>Start Date</th>
                          <th>End Date</th>
                          <th>Dewa</th>
                          <th>Maintenance</th>
                          <th>Action</th>
                      </tr>
                      </thead>
                      <tbody className="bg-white">
                      { rent?.length > 0 && rent.map((singleRent, index) => {
                          if(!singleRent.endDate){
                              return;
                          }
                              return (
                                  <tr key={index}>
                                      <td>{singleRent.buildingName}</td>
                                      <td>{singleRent.roomName}</td>
                                      <td>{singleRent.customerName}</td>
                                      <td>
                                          {singleRent.rent} / {singleRent.rentType === '1' ? "Month" : "Year"}
                                          {singleRent.contractedImage &&
                                          <div  className="transactionTableImage">
                                              <ModalImage
                                                  small={process.env.REACT_APP_APIPATH + "/api/images/" + singleRent.contractedImage}
                                                  large={process.env.REACT_APP_APIPATH + "/api/images/" + singleRent.contractedImage}
                                              />
                                          </div>}
                                      </td>
                                      <td>{date_time_to_date_format(singleRent.startDate)}</td>
                                      <td>{date_time_to_date_format(singleRent.endDate)}</td>
                                      <td>
                                          {singleRent.dewa === '1' ?
                                              (<div className="badge badge-success">Yes</div>) :
                                              (<div className="badge badge-warning">No&nbsp;</div>)}
                                      </td>
                                      <td>
                                          {singleRent.maintenance === '1' ?
                                              (<div className="badge badge-success">Yes</div>) :
                                              (<div className="badge badge-warning">No&nbsp;</div>)}
                                      </td>
                                      <td>
                                          <div className="d-flex align-items-center list-action">
                                              <Link className="badge bg-success mr-2" data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Detail" data-original-title="Detail"
                                                    to={'/rent/' + singleRent.id}><i
                                                  className="ri-eye-line mr-0"></i></Link>
                                              <Link className="badge bg-success mr-2" data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Transaction" data-original-title="Transaction"
                                                    to={`/transactions/add?type=rent&id=${singleRent.id}`}><i
                                                  className="ri-money-dollar-circle-line mr-0"></i></Link>
                                              {/*<Link className="badge bg-success mr-2" data-toggle="tooltip"*/}
                                              {/*      data-placement="top"*/}
                                              {/*      title="" data-original-title="Checkout"*/}
                                              {/*      to={'/rooms/edit/' + singleRent.id}><i*/}
                                              {/*    className="ri-picture-in-picture-exit-fill mr-0"></i></Link>*/}
                                          </div>
                                      </td>
                                  </tr>
                              );
                      })}
                      </tbody>
                  </table>
              </div>
          </div>
          <div className="col-lg-12">
              <div className="d-flex flex-wrap align-items-center justify-content-between ">
                  <div>
                      <h4 className="mb-3 mt-5">Transactions</h4>
                  </div>
              </div>
          </div>
          <ListTransactions  currentUser={currentUser} customerId={params.id} transactionType="1" transactionFor="customer"/>
      </>
  );
}

export default CustomerDetails;
